module.exports = __webpack_public_path__ + "static/RR4-d5e119af156e60e16640e86ab55cc8e1.jpg";